export default {
  name: "EmptyLayout",
  render(h) {
    return h('router-view')
  }
}
